// redux/reducers/uploadReducer.js
import * as actionTypes from "../constants/uploadConstants";

export const imageDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.DELETE_IMAGE_REQUEST:
      return { loading: true };
    case actionTypes.DELETE_IMAGE_SUCCESS:
      return { loading: false, success: true };
    case actionTypes.DELETE_IMAGE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const uploadReducer = (state = { images: [] }, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_REQUEST:
      return { loading: true, images: [] };
    case actionTypes.UPLOAD_SUCCESS:
      return { loading: false, images: action.payload };
    case actionTypes.UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
